var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconExitRight = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M12.75 4.5C12.336 4.5 12 4.836 12 5.25C12 5.664 12.336 6 12.75 6H18C18.414 6 18.75 6.336 18.75 6.75V17.25C18.75 17.664 18.414 18 18 18H12.75C12.336 18 12 18.336 12 18.75C12 19.164 12.336 19.5 12.75 19.5H18C19.2428 19.5 20.25 18.4928 20.25 17.25V6.75C20.25 5.50725 19.2428 4.5 18 4.5H12.75Z", fill: "black" }),
            React.createElement("path", { d: "M10.7198 14.4699L12.4395 12.7501H4.5C4.086 12.7501 3.75 12.4141 3.75 12.0001C3.75 11.5861 4.086 11.2501 4.5 11.2501H12.4395L10.7198 9.53036C10.4273 9.23786 10.4273 8.76236 10.7198 8.46986C11.0122 8.17736 11.4878 8.17736 11.7802 8.46986L14.7803 11.4699C15.0728 11.7624 15.0728 12.2379 14.7803 12.5304L11.7802 15.5304C11.4878 15.8229 11.0122 15.8229 10.7198 15.5304C10.4273 15.2379 10.4273 14.7624 10.7198 14.4699Z", fill: "black" }))),
        alt: 'ExitRight',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconExitRight;
//# sourceMappingURL=index.js.map